import { flexRender } from '@tanstack/react-table';
import classnames from 'classnames';

import { FontAwesomeIcon, If, Then } from '@hsp/react-component-library';

import { useSortClick, useTableStoreSelector } from 'components/table/hooks';
import { IHeaderProps } from 'types/components/table/components/header';

function Header<TData>({ enabled = true, onSort, table }: IHeaderProps<TData>) {
  const sorting = useTableStoreSelector((state) => state.sorting) ?? [];
  const handleSortClick = useSortClick();

  return (
    <If condition={enabled}>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map(({ colSpan, column, getContext, getSize, id, isPlaceholder }) => {
              return (
                <th
                  colSpan={colSpan}
                  key={id}
                  style={{
                    maxWidth: getSize() !== 150 ? getSize() : undefined,
                    width: getSize() !== 150 ? getSize() : undefined,
                  }}>
                  {isPlaceholder ? null : (
                    <div
                      className={classnames({ 'header-sort': column.getCanSort() })}
                      onClick={(e) => handleSortClick(e, column, sorting, onSort)}>
                      <div className="text-truncate">{flexRender(column.columnDef.header, getContext())}</div>
                      {{
                        asc: (
                          <FontAwesomeIcon
                            className="ms-2"
                            icon={['fas', 'sort-up']}
                          />
                        ),
                        desc: (
                          <FontAwesomeIcon
                            className="ms-2"
                            icon={['fas', 'sort-down']}
                          />
                        ),
                      }[column.getIsSorted() as string] ?? (
                        <If condition={column.getCanSort()}>
                          <Then>
                            {() => {
                              return (
                                <FontAwesomeIcon
                                  className="ms-2"
                                  icon={['fas', 'sort']}
                                />
                              );
                            }}
                          </Then>
                        </If>
                      )}
                    </div>
                  )}
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
    </If>
  );
}

export default Header;
